import clsx, { ClassValue } from 'clsx';
import { FC, ReactNode, useRef } from 'react';

interface ITooltip {
  text: ReactNode;
  position?: 'top' | 'bottom' | 'right' | 'left';
  className?: ClassValue;
  children: ReactNode;
}

const positions = {
  top: 'bottom-full left-[50%] translate-x-[-50%] -translate-y-2',
  left: 'top-0 right-full mr-4',
  bottom: 'top-full left-[50%] translate-x-[-50%] translate-y-2',
  right: 'top-0 left-full ml-4'
};

const positionsPointer = {
  top: 'top-full left-[50%] translate-x-[-50%] -translate-y-2',
  left: 'right-[-6px]',
  bottom: 'bottom-full left-[50%] translate-x-[-50%] translate-y-2',
  right: 'left-[-6px]'
};

const Tooltip: FC<ITooltip> = ({ text, position = 'top', className, children }) => {
  const tipRef = useRef<any>(null);

  function handleMouseEnter() {
    tipRef.current.style.opacity = 1;
  }

  function handleMouseLeave() {
    tipRef.current.style.opacity = 0;
  }

  const classContainer = clsx(
    'w-max absolute z-50',
    positions[position],
    className,
    'text-sm px-2 py-1 rounded flex items-center transition-all duration-150 pointer-events-none'
  );

  const pointerClasses = clsx(
    'h-3 w-3 absolute z-50',
    positionsPointer[position],
    className,
    'rotate-45 pointer-events-none'
  );

  return (
    <div
      className="relative flex items-center"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className={clsx(classContainer, 'opacity-0')} ref={tipRef}>
        <div className={pointerClasses} />
        {text}
      </div>
      {children}
    </div>
  );
};

export default Tooltip;
